import { render, staticRenderFns } from "./AddSeparatorModal.vue?vue&type=template&id=a689e814&"
import script from "./AddSeparatorModal.vue?vue&type=script&lang=js&"
export * from "./AddSeparatorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports